import { useQuery } from '@tanstack/vue-query'
import { investorsQueryKeys } from '../investorsQueryKeys'
import { getRejectedInvestorsStatusCounts } from '../investorsEndpoints'

export function useRejectedInvestorsStatusCountsQuery() {
  return useQuery({
    queryKey: investorsQueryKeys.rejectedStatusCounts(),
    queryFn: getRejectedInvestorsStatusCounts,
    staleTime: 1000 * 30,
  })
}
